import styled from '@emotion/styled'
import { Label } from 'shared/ui'

export const Row = styled('div')`
  margin-bottom: ${props => props.theme.spacing['5']};
`

export const Key = styled('span')`
  font-weight: 500;
`

export const TopSection = styled('div')``

export const Section = styled('div')`
  padding: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${props => props.theme.color.monochrome.medium};

  &:last-child {
    border: 0;
  }
`

export const SectionLabel = styled(Label)`
  margin-bottom: 10px;
`
